import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useOutputDetailsModel } from "./outputDetailsModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailLookForm } = useOutputDetailsModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const goBack = async () => {
        replaceNav(selectedNavId, "4-4")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
    </>


    const orderStatu: IDescription[] = [
        {
            label: Locale["Stock-out Doc No."],//"出库单号",
            value: detailLookForm?.tradeCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}